import {
	CaseReducer,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { STATUS } from '../globalContext/globalContext.interfaces';
import { IFilterContext } from '../globalContext/filterContext.interface';
import { RootState } from '../store';


type State = IFilterContext

const setPageReducer: CaseReducer<State, PayloadAction<number>> = (state, action) =>
{
	state.page = action.payload
}

const setOrderReducer: CaseReducer<State, PayloadAction<number>> = (state, action) =>
{
	state.order = action.payload
}

export const initialState: State = {
	status: STATUS.idle,
	message: undefined,
	filtros: [],
	order: 1,
	page: 1
}

const setFiltersReducer: CaseReducer<State, PayloadAction<Partial<State>>> = (state, action) =>
{
	const {
		filtros
	} = action.payload
	if (filtros)
		state.filtros = filtros
}

export const FilterSlice = createSlice({
	name: 'filter',
	initialState,
	reducers: {
		setFilter: setFiltersReducer,
		setPage: setPageReducer,
		setOrder: setOrderReducer
	}
})

export const serializeFilterValue = (_filterState: IFilterContext) =>
	_filterState.filtros !== undefined || _filterState.filtros !== null ? _filterState.filtros
		.map(f => [f.id, f.values.
			map(v => [v.id, v.value?.join(","), v.ranges?.join(",") || ""]
				.join(";"))])
		.join("|") : "" +
		_filterState.order

export const selectFilter = (state: RootState) => state.FilterState;
export const selectPage = (state: RootState) => state.FilterState.page;
export const selectOrder = (state: RootState) => state.FilterState.order;
export const { setFilter, setPage, setOrder } = FilterSlice.actions;